// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth } from 'firebase/auth';
import {getFirestore} from 'firebase/firestore';
import { getFunctions } from 'firebase/functions';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCqTcwcVGNrOA3VG7olcL67RpbvIC7tKdg",
  authDomain: "hvacrmi.firebaseapp.com",
  databaseURL: "https://hvacrmi-default-rtdb.firebaseio.com",
  projectId: "hvacrmi",
  storageBucket: "hvacrmi.appspot.com",
  messagingSenderId: "475795867536",
  appId: "1:475795867536:web:10218da9428a7e1d735515"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

//Initialize and export Firebase Authentication
export const auth = getAuth(app);
export const db = getFirestore(app);       // Correct method for Firestore in SDK v9
export const functions = getFunctions(app);

// Export the config for use in service worker
export const getFirebaseConfig = () => firebaseConfig;
